module.exports = __webpack_public_path__ + "static/img/ct5.093cdcf.jpg";